import { useMemo } from 'react';

import { ProgressIndicatorItem } from 'components/ProgressIndicator';
import { useStatusContext } from 'pages/Status/context';

import { DECLINED_STEPS } from './constants';
import { getFinanceItems, getNonFinanceItems } from './helpers';

import { getLenderStatus } from '../helpers';

export interface ProgressIndicatorHook {
  items: ProgressIndicatorItem[];
}

export type ApplyFinancePage = 'welcome' | 'terms' | 'form';

export default function useProgressIndicator(): ProgressIndicatorHook {
  const {
    isLoading,
    job,
    credit,
    provider,
    deposit,
    isFinanced,
    isPaidByBank,
    isPaidByCard,
    isDeclined,
  } = useStatusContext();

  const lenderStatus = useMemo(
    () =>
      getLenderStatus(job, credit, provider, deposit, isFinanced, isLoading),
    [job, credit, provider, deposit, isFinanced, isLoading],
  );

  const items: ProgressIndicatorItem[] = useMemo(() => {
    if (isDeclined) return DECLINED_STEPS;
    if (isPaidByBank || isPaidByCard) return getNonFinanceItems(lenderStatus);
    return getFinanceItems(lenderStatus);
  }, [isDeclined, isPaidByBank, isPaidByCard, lenderStatus]);

  return {
    items,
  };
}
